<div class="row">
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        
        <div class="row">
            <div class="col-12">

                <div class="alert lastLogin" role="alert">
                    <div style="width:100%">
                        <div class="p-0" style="width:100%">
                            <a class="click" (click)="loadNewSinceLastVisit()">
                                <li>{{ 'pages.support.dashboard.sinceLastVisitNewPre' | translate }} {{casesCreatedSinceLastLogin}} {{ 'pages.support.dashboard.sinceLastVisitNewPost' | translate }}</li>
                            </a>
                            <a class="click" (click)="loadUpdatedSinceLastVisit()">
                                <li>{{ 'pages.support.dashboard.sinceLastVisitUpdatePre' | translate }} {{casesUpdatedSinceLastLogin}} {{ 'pages.support.dashboard.sinceLastVisitUpdatePost' | translate }}</li>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
</div>


<div class="row pb-3">
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">

        <div class="row">
            <div class="col-12">

                <div class="card">
                    <div class="card-body">
                        <div class="card-title justify-content-right">
                            <h6>
                                <div class="custom-control custom-switch right mr-3" style="float:left" data-toggle="tooltip" data-placement="top" title="{{ 'pages.support.dashboard.enableAdSearchDesc' | translate }}">
                                    <input type="checkbox" class="custom-control-input" id="advanceSearch" [(ngModel)]="advSearch">
                                    <label class="custom-control-label" for="advanceSearch">{{ 'pages.generic.advancedSearch' | translate }} </label>
                                </div>
                                <div class="custom-control custom-switch right" style="float:left" data-toggle="tooltip" data-placement="top" title="{{ 'pages.support.dashboard.enableSavedSearchDeas' | translate }}">
                                    <input type="checkbox" class="custom-control-input" id="hideSaveSearch" [(ngModel)]="hideSaveSearch">
                                    <label class="custom-control-label" for="hideSaveSearch">{{ 'pages.generic.savedSearches' | translate }}</label>
                                </div>
                            </h6>
                        </div>
                        <form>
                            <div class="form-row">
                                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-3" data-toggle="tooltip" data-placement="top" title="{{ 'pages.support.dashboard.caseNumSearchDesc' | translate }}">
                                    <label for="caseNumber">{{ 'pages.support.dashboard.fieldTitles.reference' | translate }} </label>
                                    <input type="text" class="form-control" name="caseNumber" aria-describedby="caseNumber" placeholder="" [(ngModel)]="caseNumber">
                                </div>
                                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-3">
                                    <label for="subject">{{ 'pages.support.dashboard.fieldTitles.subject' | translate }}</label>
                                    <input type="text" class="form-control" name="subject" aria-describedby="subject" [(ngModel)]="subject">
                                </div>
                                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-3">
                                    <label for="type">{{ 'pages.support.dashboard.fieldTitles.type' | translate }}</label>
                                    <!-- <select class="form-control" name="type" aria-describedby="type" [(ngModel)]="type">
                                        <option></option>
                                        <option value="{{tt}}" *ngFor="let tt of caseTypeCV">{{tt}}</option>
                                    </select> -->
                                    <ng-multiselect-dropdown
                                  
                                    [settings]="dropdownSettings"
                                    [data]="caseTypeCV"
                                    [(ngModel)]="type"
                                    name="typeFilter"
                                    >
                                    </ng-multiselect-dropdown>
                                </div>
                                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-3">
                                    <label for="type"  title="{{ 'pages.support.dashboard.fieldTitles.trueFalsePositiveDesc' | translate }}">{{ 'pages.support.dashboard.fieldTitles.trueFalsePositive' | translate }}</label>
                                    <app-help message="{{ 'pages.support.dashboard.trueFalsePositivesHelpDesc' | translate }}"></app-help>
                                    <select class="form-control" name="trueFalsePositives" aria-describedby="trueFalsePositives" [(ngModel)]="trueFalsePositives">
                                        <option value="0"></option>
                                        <option value="1">True</option>
                                        <option value="2">False</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3" data-toggle="tooltip" data-placement="top" title="{{ 'pages.support.dashboard.prioritySearchDesc' | translate }}">
                                    <label for="priority">{{ 'pages.support.dashboard.fieldTitles.priority' | translate }}</label>
                                    <!-- <select class="form-control" name="priority" aria-describedby="priority" [(ngModel)]="priority">
                                        <option></option>
                                        <option value="{{tt}}" *ngFor="let tt of casePriorityCV">{{tt}}</option>
                                    </select> -->
                                    <ng-multiselect-dropdown
                                    [settings]="dropdownSettings"
                                    [data]="casePriorityCV"
                                    [(ngModel)]="priority"
                                    name="priorityFilter"
                                    >
                                    </ng-multiselect-dropdown>
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                    <label for="status">{{ 'pages.support.dashboard.fieldTitles.status' | translate }}</label>
                                    <select class="form-control" name="status" aria-describedby="status" [(ngModel)]="status">
                                        <option></option>
                                        <option value="{{tt}}" *ngFor="let tt of caseStatusCV">{{tt}}</option>
                                    </select>
                                </div> 
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                    <label for="status">{{ 'pages.support.dashboard.fieldTitles.contact' | translate }}</label>
                                    <ng-multiselect-dropdown
                                    [settings]="dropdownSettingsContact"
                                    [data]="contacts"
                                    [(ngModel)]="contactEmail"
                                    name="contactsFilter"
                                    (onSelect) = "contactFilterChange($event)"
                                    >
                                    </ng-multiselect-dropdown>
                                </div> 
                            </div>


                            <div [ngbCollapse]="!advSearch" id="advSearch">
                                <div class="form-row">
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                        <label for="status">Created By</label>
                                        <ng-multiselect-dropdown
                                        [settings]="dropdownSettingsCreatedBy"
                                        [data]="contactsCreatedBy"
                                        [(ngModel)]="createdByEmail"
                                        name="createdByFilter"
                                        >
                                        </ng-multiselect-dropdown>
                                    </div> 
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                        <label for="asset">{{ 'pages.support.dashboard.fieldTitles.asset' | translate }}</label>
                                        <app-help message="{{ 'pages.support.dashboard.assetHelpDesc' | translate }}"></app-help>
                                        <select class="form-control" name="asset" aria-describedby="asset" [(ngModel)]="asset">
                                            <option></option>
                                            <option value="{{tt.serialNumber}}||{{tt.name}}" *ngFor="let tt of caseAssetCV">{{tt.fullName}}</option>
                                        </select>
                                    </div>
                                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                                        <label for="escalation">{{ 'pages.support.dashboard.fieldTitles.escalation' | translate }}</label>
                                        <select class="form-control" name="escalation" aria-describedby="escalation" [(ngModel)]="escalation">
                                            <option></option>
                                            <option value="To Customer">{{ 'pages.support.dashboard.fieldTitles.escalationToUs' | translate }}</option>
                                            <option value="from Customer">{{ 'pages.support.dashboard.fieldTitles.escalationToOCD' | translate }}</option>
                                        </select>
                                    </div>
                                 
                                </div>

                                <div class="form-row">
                                    <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3" data-toggle="tooltip" data-placement="top" title="{{ 'pages.support.dashboard.createDateSearchDesc' | translate }}">
                                        <label for="publishDate">{{ 'pages.support.dashboard.fieldTitles.createdToFrom' | translate }}</label>
                                        <div class="row">
                                            <div class="col-6" style="padding-right: 0;">
                                                <input type="date" class="form-control" name="createdFrom" aria-describedby="createdFrom" [(ngModel)]="createdFrom">
                                            </div>
                                            <div class="col-6" style="padding-left: 0;">
                                                <input type="date" class="form-control" name="createdTo" aria-describedby="createdTo" [(ngModel)]="createdTo">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <label for="publishDate">{{ 'pages.support.dashboard.fieldTitles.created' | translate }}</label>
                                        <select class="form-control" name="createdPeriod" aria-describedby="createdPeriod" [(ngModel)]="createdPeriod">
                                            <option></option>
                                            <option value="1w">This week</option>
                                            <option value="2w">Last two weeks</option>
                                            <option value="thismonth">This month</option>
                                            <option value="lastmonth">Last month</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-row">   
                                    <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <label for="publishDate">{{ 'pages.support.dashboard.fieldTitles.updatedToFrom' | translate }}</label>
                                        <div class="row">
                                            <div class="col-6" style="padding-right: 0;">
                                                <input type="date" class="form-control" name="updatedFrom" aria-describedby="updatedFrom" [(ngModel)]="updatedFrom">
                                            </div>
                                            <div class="col-6" style="padding-left: 0;">
                                                <input type="date" class="form-control" name="updatedTo" aria-describedby="updatedTo" [(ngModel)]="updatedTo">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3" data-toggle="tooltip" data-placement="top" title="{{ 'pages.support.dashboard.closeDateSearchDesc' | translate }}">
                                        <label for="publishDate">{{ 'pages.support.dashboard.fieldTitles.closedToFrom' | translate }}</label>
                                        <div class="row">
                                            <div class="col-6" style="padding-right: 0;">
                                                <input type="date" class="form-control" name="closedDateFrom" aria-describedby="closedDateFrom" [(ngModel)]="closedDateFrom">
                                            </div>
                                            <div class="col-6" style="padding-left: 0;">
                                                <input type="date" class="form-control" name="closedDateTo" aria-describedby="closedDateTo" [(ngModel)]="closedDateTo">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                               
                            </div>
                            
                            <button class="btn btn-primary" (click)="search();">{{ 'pages.generic.filter' | translate }}</button>
                            <button class="btn btn-primary" (click)="reset();">{{ 'pages.generic.reset' | translate }}</button>
                            <button class="btn btn-primary" (click)="exportReport(content);" data-toggle="tooltip" data-placement="top" title="{{ 'pages.support.dashboard.downloadResDesc' | translate }}">{{ 'pages.generic.generateReport' | translate }}</button>
                            <button class="btn btn-primary" (click)="openSearchModal(saveSearch)" *ngIf="searched" data-toggle="tooltip" data-placement="top" title="{{ 'pages.support.dashboard.saveSearchDesc' | translate }}">{{ 'pages.generic.saveSearch' | translate }}</button>
                            
                            <ngb-alert *ngIf="fileUploaded" style="margin-top:10px" type="success">{{ 'pages.generic.fileuploaded'  | translate }} </ngb-alert>

                        </form>

                    </div>
                </div>
                
            </div>
        </div>

        <div class="row pt-1" *ngIf="savedSearches && savedSearches.length > 0" [ngbCollapse]="!hideSaveSearch" id="savedSearch">
            <div class="col-12">
                <div class="card">
                    <div class="card-body p-1">
                        <span style="float:left" *ngFor="let search of savedSearches">
                            <button class="btn btn-primary" (click)="loadSearch(search);">{{search.name}}  <fa-icon [icon]="['fas', 'trash']" class="pl-2" (click)="deleteSearch($event, confirmDeleteSearch, search)"></fa-icon></button>
                        </span>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
</div>

<div class="row rowfiller">
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
    <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">

        <div class="row pt-1">
            <div class="col-12 justify-content-right">
                <ng-template #listView>{{ 'pages.support.dashboard.listIconDesc' | translate }}</ng-template>
                <ng-template #boxView>{{ 'pages.support.dashboard.boxIconDesc' | translate }}</ng-template>
                <ng-template #editColumnsTooltip> {{ 'pages.support.dashboard.spannerIconDesc' | translate }}</ng-template>
                <fa-icon [icon]="['fas', 'wrench']" size="2x" class="p-1 click" (click)="editColumns(editcolumns)" [ngbTooltip]="editColumnsTooltip"></fa-icon>
                <fa-icon [icon]="['fas', 'th-list']" size="2x" class="p-1 click" (click)="changeViewType('list')" [ngbTooltip]="listView"></fa-icon>
                <fa-icon [icon]="['fas', 'th-large']" size="2x" class="p-1 click" (click)="changeViewType('grid')" [ngbTooltip]="boxView"></fa-icon>

            </div>
        </div>


        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a title="{{ 'pages.support.dashboard.casesDesc' | translate }}" class="nav-link" [ngClass]="{ 'active' : page === 'cases' }" (click)="page = 'cases'; latestCases();">{{ 'pages.support.dashboard.cases' | translate }} </a>
            </li> 
            <li class="nav-item">
                <a title="{{ 'pages.support.dashboard.flagDesc' | translate }}" class="nav-link" [ngClass]="{ 'active' : page === 'flagged' }" (click)="loadFlagged();" >{{ 'pages.generic.flagged' | translate }} <span class="badge badge-primary ml-2" style="padding:0.1rem 0.5rem;" *ngIf="flagRefs">{{flagRefs.length}}</span> </a>
            </li>
            <!-- <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : page === 'analytics' }" (click)="page = 'analytics';  loadAnalytics();">{{ 'pages.generic.analytics' | translate }}</a>
            </li> -->
        </ul>

        <br/>
        <p *ngIf="page !== 'cases' || !casesCount" >&nbsp;</p>
        <p *ngIf="casesCount && page === 'cases'">{{casesCount}} Cases found</p>


        <div class="card-body p-t-1 p-0" *ngIf="viewType === 'list' && (page === 'cases' || page === 'flagged')">
            <app-support-list [selectedColumns]="selectedColumns" [cases]="cases" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loaded]="casesLoaded" (flagEmitter)="flag($event);" (sortEmitter)="sortResults($event);"></app-support-list>
        </div>

        <div class="card-body p-t-1 p-0" *ngIf="viewType === 'grid' && (page === 'cases' || page === 'flagged')">
            <app-support-grid [cases]="cases" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loaded]="casesLoaded" (flagEmitter)="flag($event);"></app-support-grid>
        </div>

        <div class="card-body justify-content-center p-t-1 p-3" *ngIf="casesLoaded && !trueFalsePositives">
            <ngb-pagination [collectionSize]="casesCount" pageSize="{{perPage}}" page="currentPage" [(page)]="currentPage" [maxSize]="10" aria-label="Pagination" (pageChange)="onPageChange($event)" *ngIf="(page === 'cases')">
                <ng-template ngbPaginationPrevious></ng-template>
                <ng-template ngbPaginationNext></ng-template>
            </ngb-pagination>
        </div>

    </div>
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
</div>


<ng-template #saveSearch let-modal>
    <form>
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">{{ 'pages.generic.saveSearchModal' | translate }}</h4>
            <button type="button" class="cancel" aria-label="cancel" (click)="modal.dismiss('close')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="col-12">
                <label for="reference">{{ 'pages.generic.saveSearchName' | translate }}</label>
                <input type="text" class="form-control" name="searchName" aria-describedby="searchName"  [(ngModel)]="searchName">
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" [disabled]="!searchName" (click)="modal.close('save')">{{ 'pages.generic.save' | translate }}</button>
            <button type="button" class="btn btn-secondary" (click)="modal.close('close')">{{ 'pages.generic.close' | translate }}</button>
        </div>
    </form>
</ng-template>

<ng-template #confirmDeleteSearch let-modal>
    <form>
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">{{ 'pages.generic.deleteSearchModal' | translate }}</h4>
            <button type="button" class="cancel" aria-label="cancel" (click)="modal.dismiss('close')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <p>
                {{ 'pages.generic.deleteSearchConfirm' | translate }}
            </p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary"  (click)="modal.close('delete')">{{ 'pages.generic.confirm' | translate }}</button>
            <button type="button" class="btn btn-secondary" (click)="modal.close('close')">{{ 'pages.generic.close' | translate }}</button>
        </div>
    </form>
</ng-template>
<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'pages.generic.generateReport' | translate }}</h5>
    </div>
    <div class="modal-body">
        <div class="form-group col-12 pt-2">
            <label for="contact">{{ 'pages.generic.reportName' | translate }}</label>
            <input type="text" class="form-control" name="PDFName" aria-describedby="PDFName" [(ngModel)]="PDFName">
        </div>
        <div class="row">
            <div class="col-6">
                <select class="form-control" name="reportOpt" aria-describedby="reportOpt" [(ngModel)]="reportOption">
                    <option value="pdf">PDF</option>
                    <option value="csv">CSV</option>
                </select>
            </div>
            <div class="col-6">
                <select class="form-control" name="reportLevel" aria-describedby="reportLevel" [(ngModel)]="pdfAccessLevel">
                    <option title="{{ 'pages.generic.ACCESS_INTERNAL_REPORTS' | translate }}" value="0">{{ 'pages.generic.internal' | translate }}</option>
                    <option title="{{ 'pages.generic.ACCESS_CONFIDENTIAL_REPORTS' | translate }}" value="1">{{ 'pages.generic.confidential' | translate }}</option>
                    <option title="{{ 'pages.generic.ACCESS_RESTRICTED_REPORTS' | translate }}" value="2">{{ 'pages.generic.restricted' | translate }}</option>
            </select>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">{{ 'pages.generic.close' | translate }}</button>
        <button type="button" class="btn btn-primary" (click)="modal.close('save')">{{ 'pages.generic.save' | translate }}</button>
    </div>
</ng-template>

<ng-template #editcolumns let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Columns Selection</h5>
    </div>
    <div class="modal-body">
        <div class="form-group col-12 pt-2">
            <label for="contact">Select Columns to Display</label>
            <ng-multiselect-dropdown
            [settings]="dropdownSettingsColumns"
            [data]="columnsSelection"
            [(ngModel)]="selectedColumns"
            name="columnFilter"
            >
            </ng-multiselect-dropdown>
        </div>
        
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">{{ 'pages.generic.close' | translate }}</button>
        <button type="button" class="btn btn-primary" (click)="modal.close('save')">{{ 'pages.generic.save' | translate }}</button>
    </div>
</ng-template>